import Typography from "@material-ui/core/Typography";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import { fontConfig } from "theme/fontConfig";
import InfoTooltip from "components/InfoTooltip";

const DepositsRadioTabs = ({ handleChange, value }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
    {/* the hint describes both options, so it sits on a label for the whole group; opens below so it never covers the Finance tabs */}
    <span style={{ display: 'flex', alignItems: 'center', gap: '6px', marginRight: '24px', position: 'relative', top: '-3px' }}>
      <Typography variant="caption"
        style={{
          fontSize: "14px",
          fontFamily: fontConfig.FinanceDepositsRadioTabsTextFont.family,
        }}
      >View</Typography>
      <InfoTooltip placement="bottom" text="Awaiting To Batch shows payments not yet grouped into a deposit batch. Batches shows payments already grouped and ready to reconcile." />
    </span>
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={(event) => {
          handleChange(event.target.value)
        }}
        value={value}
      >
        <FormControlLabel value="Awaiting To Batch" control={<Radio />}
          label={<Typography variant="caption"
            style={{
              fontSize: "14px",
              fontFamily: fontConfig.FinanceDepositsRadioTabsTextFont.family,
            }}
          >Awaiting To Batch</Typography>}

        />
        <FormControlLabel value="Batches" control={<Radio />}
          label={<Typography variant="caption"
            style={{
              fontSize: "14px",
              fontFamily: fontConfig.FinanceDepositsRadioTabsTextFont.family,
            }}
          >Batches</Typography>}

        />
      </RadioGroup>
    </FormControl>
    </div>
  )
}

export default DepositsRadioTabs